module.exports = __webpack_public_path__ + "img/banner-logo.ab83ddd5.png";